import React from 'react';
import './style.scss';
import TeamMember, { TeamMemberColors, TeamMemberProps } from './member';
import useWindowSize from '../../../../../../../hooks/useWindowSize';
import { ArrayOfSize } from 'shared';

const members: ArrayOfSize<TeamMemberProps, 5> = [
  {
    color: TeamMemberColors.PURPLE,
    src: '/assets/images/landing/pre_footer/team/avatar1.png',
    name: 'Sergey Mast',
    role: 'Chief Wanker Officer'
  },
  {
    color: TeamMemberColors.GREEN,
    src: '/assets/images/landing/pre_footer/team/avatar2.png',
    name: 'The Greg',
    role: 'Chief Tech Wanker'
  },
  {
    color: TeamMemberColors.PINK,
    src: '/assets/images/landing/pre_footer/team/avatar3.png',
    name: 'Adrian Louis Vicente',
    role: '3D Wanker'
  },
  {
    color: TeamMemberColors.BLUE,
    src: '/assets/images/landing/pre_footer/team/avatar4.png',
    name: 'Mark Fillon',
    role: 'Game Design Consultant (also wanker)'
  },
  {
    color: TeamMemberColors.YELLOW,
    src: '/assets/images/landing/pre_footer/team/avatar5.png',
    name: 'DaleGerous',
    role: 'Community Wanker'
  }
];

const TeamComponent = () => {
  const [sizeX] = useWindowSize();

  if (sizeX > 850) {
    return (
      <div className='lfst-team'>
        <div className='lfst-team-row lfst-team-row-1'>
          <TeamMember {...members[0]} />
        </div>
        <div className='lfst-team-row lfst-team-row-2'>
          <TeamMember {...members[1]} />
          <TeamMember {...members[2]} />
        </div>
        <div className='lfst-team-row lfst-team-row-1'>
          <div className='lfst-team-member-ph' />
          <div className='lfst-team-members-wrapper'>
            <TeamMember {...members[3]} />
            <TeamMember {...members[4]} />
          </div>
          <div className='lfst-team-member-ph' />
        </div>
      </div>
    );
  }

  return (
    <div className='lfst-team'>
      <div className='lfst-team-row'>
        <TeamMember {...members[0]} className='lfst-team-member' />
      </div>
      <div className='lfst-team-row'>
        <TeamMember {...members[1]} className='lfst-team-member' />
      </div>
      <div className='lfst-team-row'>
        <TeamMember {...members[2]} className='lfst-team-member' />
      </div>
      <div className='lfst-team-row'>
        <TeamMember {...members[3]} className='lfst-team-member' />
      </div>
      <div className='lfst-team-row'>
        <TeamMember {...members[4]} className='lfst-team-member' />
      </div>
    </div>
  );
};

export default TeamComponent;
